// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lCwo","newExpiryDate":"styles_newExpiryDate__2xs31","footer":"styles_footer__1GZuM"};